// utils/audio.ts
/**
 * hex → Uint8Array
 */
export function hexToUint8Array(hex) {
    // 공백을 허용하고, 0x 접두어는 제거
    const clean = hex.replace(/0x|[\s,]/g, "");
    if (clean.length % 2 !== 0) throw new Error("Invalid hex length");
    const bytes = new Uint8Array(clean.length / 2);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = parseInt(clean.substr(i * 2, 2), 16);
    }
    return bytes;
}

/**
 * 16-bit PCM → WAV Blob
 * @param hex 16-bit little-endian PCM 샘플을 나타내는 hex 문자열
 * @param sampleRate ex) 44100, 48000
 * @param channels   1: 모노, 2: 스테레오
 */
export function pcmHexToWavBlob(
    hex,
    sampleRate = 44100,
    channels = 1
) {
    const pcmData = hexToUint8Array(hex);
    const blockAlign = channels * 2;           // 16-bit = 2 bytes
    const byteRate   = sampleRate * blockAlign;
    const wavSize    = 44 + pcmData.byteLength;

    // 44-byte WAV 헤더 만들기 (RIFF/WAVE)
    const header = new ArrayBuffer(44);
    const view   = new DataView(header);

    let offset = 0;
    const writeStr = (s) =>
        [...s].forEach((c) => view.setUint8(offset++, c.charCodeAt(0)));

    writeStr("RIFF");
    view.setUint32(offset, wavSize - 8, true); offset += 4; // ChunkSize
    writeStr("WAVE");
    writeStr("fmt ");
    view.setUint32(offset, 16, true); offset += 4;          // Subchunk1Size (PCM)
    view.setUint16(offset, 1, true);  offset += 2;          // AudioFormat = PCM
    view.setUint16(offset, channels, true); offset += 2;    // NumChannels
    view.setUint32(offset, sampleRate, true); offset += 4;  // SampleRate
    view.setUint32(offset, byteRate, true); offset += 4;    // ByteRate
    view.setUint16(offset, blockAlign, true); offset += 2;  // BlockAlign
    view.setUint16(offset, 16, true); offset += 2;          // BitsPerSample
    writeStr("data");
    view.setUint32(offset, pcmData.byteLength, true);       // Subchunk2Size

    // Blob으로 합치기
    return new Blob([header, pcmData], { type: "audio/wav" });
}